function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { cloneVNode } from '@cloud-sn/v-utils';
export function noop() {}
export function isFunction(fn) {
  return typeof fn === 'function';
}
export function getRowKey(rowKey, record, rowIdx) {
  var key = typeof rowKey === 'function' ? rowKey(record, rowIdx) : record[rowKey];
  return key === undefined ? "$$_id".concat(rowIdx) : String(key);
}
export function isPxOrPercentage(val) {
  var valStr = String(val);
  return valStr.indexOf('%') > -1 || valStr.indexOf('px') > -1;
}
export function chainFns(originFn, fn) {
  var nFn = null;

  if (isFunction(originFn) && isFunction(fn)) {
    nFn = function () {
      fn.apply(void 0, arguments);
      originFn.apply(void 0, arguments);
    };
  } else if (isFunction(originFn)) {
    nFn = function () {
      originFn.apply(void 0, arguments);
    };
  } else if (isFunction(fn)) {
    nFn = function () {
      fn.apply(void 0, arguments);
    };
  }

  return nFn;
}
export function addEventListener(element, eventName, fn) {
  element.addEventListener(eventName, fn, false);
  return {
    remove: function remove() {
      element.removeEventListener(eventName, fn);
    }
  };
}
export function getKey(column, defaultKey) {
  return column.key || "$$_id".concat(defaultKey);
}
export function flatCols() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return columns.reduce(function (r, v) {
    var nr = r;

    if (v.children) {
      nr.push.apply(nr, _toConsumableArray(flatCols(v.children)));
    } else {
      nr.push(v);
    }

    return nr;
  }, []);
}

function recursiveCols() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rowIdx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var parentFixed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var groups = [];
  var nRows = rows;
  nRows[rowIdx] = nRows[rowIdx] || [];
  var row = nRows[rowIdx];

  for (var i = 0, l = columns.length; i < l; i += 1) {
    var item = _objectSpread({}, columns[i]);

    var fixed = parentFixed;

    if (rowIdx === 0) {
      fixed = item.fixed === 'right' || item.fixed === 'left' || item.fixed === true;
    }

    item.$$_fixed = fixed;
    row.push(item);

    if (Array.isArray(item.children)) {
      item.children = recursiveCols(item.children, rowIdx + 1, rows, item.$$_fixed);
      item.colspan = 0;

      for (var j = 0, ll = item.children.length; j < ll; j += 1) {
        var child = item.children[j]; // 有层级的column,上级colspan重新计算, 忽略用户设置的colSpan, 否则会造成异常

        item.colspan += child.children ? child.colspan : 1;
      }
    }

    groups.push(item);
  }

  return groups;
}
/**
 * 保持columns结构,并计算colspan和rowspan
 */


export function groupCols() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rows = [];
  var groups = recursiveCols(columns, 0, rows); // 计算每行元素实际的rowspan

  var deep = rows.length;

  if (deep >= 1) {
    for (var i = 0; i < deep - 1; i += 1) {
      var rl = rows[i];

      for (var j = 0, l = rl.length; j < l; j += 1) {
        var item = rl[j];

        if (!item.children) {
          item.rowspan = deep - i;
        }
      }
    }
  }

  return groups;
}

function recursiveRow() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var rowIdx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var nRows = rows;
  nRows[rowIdx] = nRows[rowIdx] || [];
  var row = nRows[rowIdx];

  for (var i = 0, l = columns.length; i < l; i += 1) {
    var item = columns[i];
    var cell = {
      key: item.key,
      className: item.className,
      title: item.title,
      column: item
    };

    if ('colspan' in item) {
      cell.colspan = item.colspan;
    }

    if ('rowspan' in item) {
      cell.rowspan = item.rowspan;
    }

    row.push(cell);

    if (item.children) {
      recursiveRow(item.children, rowIdx + 1, rows);
    }
  }

  return rows;
}
/**
 * 汇总表头行的列
 */


export function groupRows() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return recursiveRow(columns, 0, []);
}

function upperCaseFirst(name) {
  var nName = String(name);
  return nName.substring(0, 1).toUpperCase() + nName.substring(1);
}

export function getRefName(fixed) {
  var baseName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var name = baseName;

  if (fixed) {
    name = "".concat(fixed).concat(upperCaseFirst(name));
  }

  return name;
}
export function flatRows() {
  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var childColName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
  var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return rows.reduce(function (r, v) {
    var nr = r;
    nr.push(deep ? _objectSpread({}, v) : v);

    if (v[childColName]) {
      nr.push.apply(nr, _toConsumableArray(flatRows(v[childColName], childColName, deep)));
    }

    return nr;
  }, []);
}
export function getFlatColumns(self) {
  var fixed = self.fixed,
      flatColumns = self.flatColumns,
      leftFlatColumns = self.leftFlatColumns,
      rightFlatColumns = self.rightFlatColumns;
  var cols = flatColumns;

  if (fixed === 'left') {
    cols = leftFlatColumns;
  } else if (fixed === 'right') {
    cols = rightFlatColumns;
  }

  return cols;
}
export function getRowStyle(rowId, rowsHeight) {
  var style = {};
  var height = rowsHeight[rowId];

  if (height) {
    style.height = height === 'auto' ? height : "".concat(height, "px");
  }

  return style;
}
export function getNormalizeContent(h, columnFixed, tableFixed, content) {
  var ret = content;

  if (columnFixed && !tableFixed) {
    ret = Array.isArray(content) ? content.map(function (v) {
      return cloneVNode(v);
    }) : cloneVNode(content);
  }

  return ret;
}
var DRAG_MIN_GAP = 10;
var DRAG_SIDE_RANGE = 0.25;
export function calcDragPosition(event, el) {
  var clientY = event.clientY;

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      bottom = _el$getBoundingClient.bottom,
      height = _el$getBoundingClient.height;

  var offset = Math.max(height * DRAG_SIDE_RANGE, DRAG_MIN_GAP);
  var position = 'inner';

  if (clientY <= top + offset) {
    position = 'top';
  } else if (clientY >= bottom - offset) {
    position = 'bottom';
  }

  return position;
}